module.exports = __webpack_public_path__ + "static/img/1.3b00dbf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news29/1.gif
// module id = b4Zq
// module chunks = 1